<template>
<svg viewBox="0 0 24 24" fill="none"
	stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
	<rect x="6" y="4" width="4" height="16"></rect>
	<rect x="14" y="4" width="4" height="16"></rect>
</svg>
</template>
